import { render, staticRenderFns } from "./ResourcePoolOptionList.vue?vue&type=template&id=4038a9d7&scoped=true&"
import script from "./ResourcePoolOptionList.vue?vue&type=script&lang=js&"
export * from "./ResourcePoolOptionList.vue?vue&type=script&lang=js&"
import style0 from "./ResourcePoolOptionList.vue?vue&type=style&index=0&id=4038a9d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4038a9d7",
  null
  
)

export default component.exports